<template>
  <dv-full-screen-container>
    <!--头部开始-->
    <el-row style="height: 10%">
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 100%">
        <div class="header">
          <div class=" header_time">
            <span class="year">{{ date }}</span>
            <span class="hour" style="margin-left: 10px">{{ time }}</span>
          </div>
          <div class="header_left_nav">
            <router-link to="/">
              <button class="butt ">首页</button>
            </router-link>
          </div>
          <div class="header_left_nav nav1" style="z-index: 100000000">
            <router-link to="/Arrondi2" >
              <button class="butt zq">文化</button>
            </router-link>
          </div>
          <div class=" header_title">
            <div class="header_img">
              <img src="../public/images/tixing.png" alt="">
              <div class="header_title_msg" style="left: 18%">
                金雀帮扶数据动态展示
              </div>
            </div>
          </div>
          <div class=" nav2 " style="z-index: 100000000">
            <router-link to="/Special2" >
              <button class="butt ">咱们店</button>
            </router-link>
          </div>
          <div class=" nav3">
            <router-link to="/SpecialCoun2" >
              <button class="butt ">农业</button>
            </router-link>
          </div>
          <div class=" nav5">
            <router-link to="/Information" >
              <button class="butt" >数据</button>
            </router-link>
          </div>
          <div class=" nav4">
            <button class="butt " v-on:click="login_out">退出</button>
          </div>
          <div class="clear-both"></div>
        </div>
      </el-col>
    </el-row>

    <!--头部完毕-->
    <div class="information-left">
      <dv-border-box-11 title="基本信息" class="information-left-header">
        <div class="box">
          <p class="desc">人人献爱心购物即帮扶,绑定你的帮扶村下单既有爱心证书推送,更会累积到你的个
            人中心帮扶订单内,帮扶资金用于被帮扶村爱心超市积分购物,助力乡村振兴事业
          </p>
          <div class="list">
            <span>注册用户：{{ num1 }}</span>
            <span>被帮扶村：{{ num2+100 }}</span>
            <span>爱心使者：{{ num3 }}</span>
            <span>交易额：{{ num4 }}</span>
            <span>帮扶资金：{{ num5 }}</span>
          </div>
        </div>
      </dv-border-box-11>

      <dv-border-box-11 title="帮扶居委" class="information-left-bottom">
        <div class="box">
          <Bing2 msg="饼图"/>
        </div>
      </dv-border-box-11>
    </div>

    <div class="information-right">
      <dv-border-box-11 title="帮扶流程图" >
        <div style="position:relative; width: 100%; height: 200px">
          <img src="../public/images/shuju.png" style="position:absolute; left: 6%; top: 18%" alt="">

          <div style="position: absolute; top: 310px; left: 230px; width: 140px ;">
            <img src="../public/images/19.gif" alt="" style="width: 120px; height: 20px">
          </div>

          <div style="position: absolute; top: 260px; left: 230px; width: 140px;  transform:skew(0,-45deg);transform-origin: left top;">
            <img src="../public/images/19.gif" alt="" style="width: 120px; height: 20px">
          </div>

          <div style="position: absolute; top: 410px; left: 230px; width: 140px; transform:skew(0,37deg);transform-origin: left top;">
            <img src="../public/images/19.gif" alt="" style="width: 120px; height: 20px">
          </div>

          <div style="position: absolute; top: 125px; left: 460px; width: 140px; transform:skew(0,38deg);transform-origin: left top;">
            <img src="../public/images/19.gif" alt="" style="width: 120px; height: 20px">
          </div>
          <div style="position: absolute; top: 310px; left: 230px; width: 140px ; left: 460px">
            <img src="../public/images/19.gif" alt="" style="width: 120px; height: 20px">
          </div>
          <div style="position: absolute; top: 505px; left: 460px; width: 140px; transform:skew(0,-35deg);transform-origin: left top;">
            <img src="../public/images/19.gif" alt="" style="width: 120px; height: 20px">
          </div>
          <div style="position: absolute; top: 324px; left: 810px; width: 140px ;">
            <img src="../public/images/19.gif" alt="" style="width: 110px; height: 20px">
          </div>
          <div style="position: absolute; top: 280px; left: 810px; width: 140px ; transform:skew(0,-32deg);transform-origin: left top;">
            <img src="../public/images/19.gif" alt="" style="width: 110px; height: 20px">
          </div>
          <div style="position: absolute; top: 365px; left: 810px; width: 140px; transform:skew(0,32deg);transform-origin: left top;">
            <img src="../public/images/19.gif" alt="" style="width: 110px; height: 20px">
          </div>
          <div style="position: absolute; top: 324px; left: 1045px; width: 140px ;">
            <img src="../public/images/19.gif" alt="" style="width: 110px; height: 20px">
          </div>
          <div style="position: absolute; top: 145px; left: 1045px; width: 140px ;">
            <img src="../public/images/19.gif" alt="" style="width: 110px; height: 20px">
          </div>

          <div style="position: absolute; top: 480px; left: 1080px; width: 80px ;">
            <img src="../public/images/19.gif" alt="" style="width: 80px; height: 20px">
          </div>

          <div style="position: absolute; top: 500px; left: 980px; width: 20px; height: 220px; transform:skew(0,0);transform-origin: left top;">
            <img src="../public/images/20.gif" alt="" style="width: 20px; height: 50px">
          </div>

          <div style="position: absolute; top: 620px; left: 1120px; width: 20px; height: 60px; transform: rotate(-75deg);transform-origin:0 50%;">
            <img src="../public/images/21.gif" alt="" style="width: 20px; height: 50px">
          </div>

          <div style="position: absolute; top: 700px; left: 980px; width: 20px; height: 220px; transform:skew(0,0);transform-origin: left top;">
            <img src="../public/images/20.gif" alt="" style="width: 20px; height: 50px">
          </div>

          <div style="position: absolute; top: 720px; left: 1080px; width: 80px ; transform:skew(0,-35deg);transform-origin: left top;">
            <img src="../public/images/19.gif" alt="" style="width: 80px; height: 20px">
          </div>

        </div>
      </dv-border-box-11>
    </div>

  </dv-full-screen-container>
</template>

<script>

import Bing2 from "@/views/zhuanqu/Bing2";


export default {
  name: "Information",
  components: {
    Bing2,
  },
  data() {
    return {
      //销售数据
      num1:'1',
      num2:'2',
      num3:'3',
      num4:'4',
      num5:'5',
      time:'',
      date:'',
      single:1,
      count:0,
      list:['a1','a2','a3','a4','a5','a6'],
      list1:['a11','a21','a31','a41','a51','a61'],
      list2:['a12','a22','a32','a42','a52','a62'],
      list3:['a13','a23','a33','a43','a53','a63'],
      list4:['a14','a24','a34','a44','a54','a64'],
      list5:['a15','a25','a35','a45','a55','a65'],
      list6:['a16','a26','a36','a46','a56','a66'],
      list7:['a17','a27','a37','a47','a57','a67'],
      list8:['a18','a28','a38','a48','a58','a68'],
      list9:['a19','a29','a39','a49','a59','a69'],


    }
  },
  created() {

    let user_id = window.localStorage.getItem('user_id');

    // if (!user_id)
    // {
    //   this.$router.push({path: '/Login'})
    //
    //   return false;
    // }

    this.$api.all_sales_amount1().then(res => {

      this.num1 = res[0];
      this.num2 = res[1];
      this.num3 = res[2];
      this.num4 = res[3];
      this.num5 = res[4];
      // this.num1 = res['0'];

    })

    var that = this;
    var timerID = setInterval(updateTime, 1000);
    updateTime();
    function updateTime() {
      var cd = new Date();
      that.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
      that.date = zeroPadding(cd.getFullYear(), 4) + '-' + zeroPadding(cd.getMonth()+1, 2) + '-' + zeroPadding(cd.getDate(), 2);
    };

    function zeroPadding(num, digit) {
      var zero = '';
      for(var i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    }
  },

  mounted(){

  },

  methods: {
    login_out:function(e){
      window.localStorage.clear();
      this.$notify({
        title: '成功',
        message: '退出登录',
        type: 'success'
      });
      this.$router.push({ path: '/Login' })
    }
  }

}
</script>

<style lang="less" scoped>
@import '../public/less/public/list.less';
@import '../public/less/information/information.less';

.el-icon-right{
  //font-size: 28px;
}
</style>